import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const Tooltip = ({ content, position, hovered }) => {
    const tooltipRef = useRef(null);

    useEffect(() => {
        const tooltip = d3.select(tooltipRef.current);

        tooltip
            .style('left', '-9999px')
            .style('top', '-9999px')
            .style('display', 'block')
            .style('min-width', '80px');
        
            const adjustPosition = (pos) => {
                if (!pos || !tooltipRef.current) return { x: 0, y: 0 };
            
                const tooltipNode = tooltipRef.current;
                const { width: tooltipWidth, height: tooltipHeight } = tooltipNode.getBoundingClientRect();
                
                // Get the viewport dimensions
                const viewportWidth = window.innerWidth;
                const viewportHeight = window.innerHeight;
            
                // Calculate initial position
                let x = pos.x;
                let y = pos.y;
            
                // Add offset from pointer
                const offsetX = 15;
                const offsetY = -20; // Increased offset to show above the pointer
                x += offsetX;
                y += offsetY;
            
                // Adjust if tooltip would go outside viewport
                if (x + tooltipWidth > viewportWidth) {
                    x = x - tooltipWidth - (offsetX * 2);
                }
            
                if (y + tooltipHeight > viewportHeight) {
                    y = y - tooltipHeight;
                }
            
                // Ensure minimum positions
                x = Math.max(0, x);
                y = Math.max(0, y);
            
                return { x, y };
            };

        const adjustedPosition = adjustPosition(position);
        
        if (content) {
            tooltip
                .style('display', 'block')
                .html(content)
                .style('left', `${adjustedPosition.x}px`)
                .style('top', `${adjustedPosition.y}px`);
        } else {
            tooltip.style('display', 'none');
        }

        if (hovered) {
            const element = d3.select(hovered);
            const parentNode = element.node() && element.node().parentNode;

            if (parentNode) {
                const parentGroup = d3.select(parentNode);
                const grandParentNode = parentGroup.node().parentNode;
                
                if (grandParentNode) {
                    grandParentNode.appendChild(parentGroup.node());
                }

                element
                    .attr('original-stroke', element.style('stroke'))
                    .attr('original-stroke-width', element.style('stroke-width'));

                element
                    .style('stroke', 'white')
                    .style('stroke-opacity', '0.8')
                    .style('stroke-width', '2px');
            }
        }

        return () => {
            if (hovered) {
                const element = d3.select(hovered);
                if (element.node()) {
                    element
                        .style('stroke', element.attr('original-stroke'))
                        .style('stroke-width', element.attr('original-stroke-width'));

                    element
                        .attr('original-stroke', null)
                        .attr('original-stroke-width', null);
                }
            }
        };
        
    }, [content, position, hovered]);

    return (
        <div ref={tooltipRef} className="tooltip" />
    );
};

export default Tooltip;